<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Sertfika Süresi Yaklaşan Cihaz</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form">

        <div class="col-xl-12 col-md-12 col-12 mb-1">
            <div class="form-group">
                <label for="name">Mail</label>
                <input type="text" class="form-control" id="name" formControlName="mail" placeholder="Mail"
                    maxlength="250" />
            </div>
        </div>

        <div class="col-xl-12 col-md-12 col-12 mb-1">
            <div class="form-group">
                <label for="name">Mail Başlığı</label>
                <input type="text" class="form-control" id="name" formControlName="title" placeholder="Başlık"
                    maxlength="250" />
            </div>
        </div>

        <div class="form-group col-xl-12 col-md-12 col-sm-12 col-12">
            <label for="name">Mail Açıklama</label>

            <quill-editor formControlName="description" [modules]="quillConfig">

            </quill-editor>
        </div>
    </form>
</div>

<div class="modal-footer d-flex">
    <button type="button" class="btn btn-danger" (click)="closeModal()" rippleEffect>
        İptal
    </button>
    <button type="button" class="btn btn-success" rippleEffect (click)="onSubmit()" [disabled]="form.invalid">
        Gönder
    </button>
</div>